import { Row, Col } from "react-bootstrap"
import Table from '../../../../../../components/Table';

interface IRankinSearchResults {
    defendantNameLabel: string,
    citationNumberLabel: string,
    issueDateLabel: string,
    descriptionLabel: string,
    balanceDueLabel: string,
    paymentOptionsLabel: string,
    minimumPartialPaymentAmount: number,
    minimumPaymentText?: string,
    minimumPaymentErrorText?: string,
    observesWeekends: boolean,
    durationOfPendingHours: number,
    overlayText: string,
    overlayBackground: string,
    overlayTextColor: string,
    overlayIconColor: string,
    noMatchFoundText: string,
    margin: string,
    padding: string,
    headerBackgroundColor: string,
    headerPadding: string,
}

export const DEFENDANT_NAME_LABEL = 'Defendant Name';
export const CITATION_NUMBER_LABEL = 'Citation Number';
export const ISSUE_DATE_LABEL = 'Issue Date';
export const DESCRIPTION_LABEL = 'Description';
export const BALANCE_DUE_LABEL = 'Balance Due';
export const PAYMENT_OPTIONS_LABEL = 'Payment Options';
export const MINIMUM_PARTIAL_PAYMENT_AMOUNT = 25;
export const MINIMUM_PAYMENT_TEXT = 'Minimum partial payment: {amount}';
export const MINIMUM_PAYMENT_ERROR_TEXT = 'Partial payments must be at least {amount}';
export const OBSERVES_WEEKENDS = false;
export const DURATION_OF_PENDING_HOURS = 24;
export const OVERLAY_TEXT = 'Your ticket is not currently payable online, please contact Rankin County or visit the office for further assistance.';
export const OVERLAY_BACKGROUND = '#fef1b5';
export const OVERLAY_TEXT_COLOR = '#1e1e1e';
export const OVERLAY_ICON_COLOR = 'orange';
export const NO_MATCH_FOUND_TEXT = 'NO MATCH FOUND';
export const MARGIN = '0px';
export const PADDING = '0px';
export const HEADER_BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const HEADER_PADDING = '0';

const checkStyleForDefault = (style: string, defaultStyle: string) => {
    return style && style !== '' ? style : defaultStyle;
}

const RankinSearchResults = ({ defendantNameLabel, citationNumberLabel, issueDateLabel, descriptionLabel, balanceDueLabel, paymentOptionsLabel,
    margin, padding, headerBackgroundColor, headerPadding }: IRankinSearchResults) => {

    if (!defendantNameLabel) { defendantNameLabel = DEFENDANT_NAME_LABEL }
    if (!citationNumberLabel) { citationNumberLabel = CITATION_NUMBER_LABEL }
    if (!issueDateLabel) { issueDateLabel = ISSUE_DATE_LABEL }
    if (!descriptionLabel) { descriptionLabel = DESCRIPTION_LABEL }
    if (!balanceDueLabel) { balanceDueLabel = BALANCE_DUE_LABEL }
    if (!paymentOptionsLabel) { paymentOptionsLabel = PAYMENT_OPTIONS_LABEL }
    if (!margin) { margin = MARGIN }
    if (!padding) { padding = PADDING }
    if (!headerBackgroundColor) { headerBackgroundColor = HEADER_BACKGROUND_COLOR }
    if (!headerPadding) { headerPadding = HEADER_PADDING }

    const initialColumns = [{
        dataField: 'defendantName',
        text: defendantNameLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'citationNumber',
        text: citationNumberLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'issueDate',
        text: issueDateLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'description',
        text: descriptionLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'balanceDue',
        text: balanceDueLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }, {
        dataField: 'id',
        text: paymentOptionsLabel,
        headerStyle: {
            backgroundColor: checkStyleForDefault(headerBackgroundColor, HEADER_BACKGROUND_COLOR)
        },
    }];

    const renderTable = () => {
        return (
            <Table
                keyField="msbId"
                data={[]}
                columns={initialColumns}
            />);
    };

    return (
        <div style={{ margin: margin, padding: padding }}>
            <Row>
                <Col>
                    {renderTable()}
                </Col>
            </Row>
        </div>
    )
}

export default RankinSearchResults;
